// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1565s","importantInfo":"styles_importantInfo__7i-NJ"};